import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-breadcrumbs', 'title', 'Breadcrumbs navigation');
